(function ($) {
    // dialogs fallback
    doDialogPolyfill();

    // ScrollSpy
    new ScrollSpy({
        yFix: 0,
        jumpTo: function (y) {
            animate(function (value) {
                document.documentElement.scrollTop = value;
            }, document.documentElement.scrollTop, y, 500);
        }
    });

    // Lien externe, autre cas
    [].forEach.call(document.querySelectorAll('a.lien_externe:not(.js-open-in-iframe-popin)'), function ($element) {
        $element.addEventListener('click', function (event) {
            event.preventDefault();
            var href = $element.getAttribute('href');
            window.open(href);
            return false;
        });
    });

    function formaterListe() {
        // Objet liste
        $(".contenu ul.objets .vignette_deco>img").each(function () {
            var cssClass = "";
            if ($(this).width() < 70) {
                cssClass = "vignette__small";
            }
            $(this).parent("div").css("background-image", "url('" + $(this).attr("src") + "')").addClass(cssClass);
            $(this).remove();
        })

    }

    function cartePartenaires() {
        const cartesPartenaires = document.querySelectorAll('[data-partenaires]');
        Array.from(cartesPartenaires).forEach(function(carte) {
            let partenairesUniv = carte.querySelectorAll('[data-partenaire-map-point]');
            Array.from(partenairesUniv).forEach(function(element) {
                element.addEventListener('mouseover', function() {
                    if (element.nextSibling) {
                        element.parentNode.appendChild(element);
                    }
                });
                element.addEventListener('click', function() {
                    const url = element.getAttribute('data-partenaire-map-point');
                    if (!!url) {
                        document.location.href = url;
                    }
                });
            });
            partenairesUniv = carte.querySelectorAll('[data-partenaire-grid-item]');
            Array.from(partenairesUniv).forEach(function(element) {
                const dialog = element.querySelector('dialog');
                element.addEventListener('click', function() {
                    if (!(dialog.open)) {
                        dialog.showModal();
                    }
                });
                dialog.addEventListener('close', function() {
                    if (dialog.returnValue === 'default') {
                        const url = element.getAttribute('data-partenaire-grid-item');
                        if (!!url) {
                            document.location.href = url;
                        }
                    }
                });
            });
        });
    }

    function doDialogPolyfill() {
        if (!(document.createElement('dialog').showModal)) {
            document.body.classList.add('no-html5-dialog-support')
        }
        var dialogs = Array.from(document.querySelectorAll('dialog'));
        // Now dialog always acts like a native <dialog>.
        dialogs.forEach(function(dialog) {
            dialogPolyfill.registerDialog(dialog);
        });
    }

    $(window).load(function () {
        formaterListe();
        cartePartenaires();
    });


    // Owl Carousel
    $('.owl-carousel').each(function(){
        var $t = $(this);
        var willBeAnimated = $t.find('.item').length > 1;
        $t.owlCarousel({
            items: 1,
            margin: 0,
            loop: willBeAnimated,
            nav: false,
            dots: false,
            autoplay: willBeAnimated,
            mouseDrag: willBeAnimated,
            touchDrag: willBeAnimated,
            autoplayTimeout: 8000,
            lazyLoad: true,
            autoplayHoverPause: true
        });
        $t.find('.owl-controls .owl-prev').click(function () {
            $t.trigger('prev.owl.carousel');
        }).end().find('.owl-controls .owl-next').click(function () {
            $t.trigger('next.owl.carousel');
        });
    });

    $(function() {
        // Owl Carousel next thumbnail
        $('.accueil__carousel__items').each(function(){
            var $t = $(this);
            var willBeAnimated = $t.find('.accueil__carousel__item').length > 1;
            var isThemeEutPlus = document.body.classList.contains('theme--eut-plus');
            var autoplay = isThemeEutPlus;
            var autoplayTimeout = isThemeEutPlus ? 8000 : undefined;
            $t.owlCarousel({
                items: 1,
                margin: 0,
                loop: willBeAnimated,
                nav: willBeAnimated || !isThemeEutPlus,
                dots: willBeAnimated && isThemeEutPlus,
                autoplay: autoplay,
                mouseDrag: willBeAnimated,
                touchDrag: willBeAnimated,
                autoplayTimeout: autoplayTimeout,
                lazyLoad: true,
                autoplayHoverPause: true,
                onInitialized:initThumbnail(willBeAnimated)
            });
            $t.on('translated.owl.carousel',function(property){
                setThumbnail();
            });
            if (willBeAnimated || !isThemeEutPlus) {
                $t.find('.owl-controls').prepend('<button class="owl-prev"><span class="icon icon-arrow-utt-left"></span></button>').append('<button class="owl-next"><span class="icon icon-arrow-utt-right"></span></button>');
                $t.find('.owl-controls .owl-prev').click(function () {
                    $t.trigger('prev.owl.carousel');
                }).end().find('.owl-controls .owl-next').click(function () {
                    $t.trigger('next.owl.carousel');
                });
            }
        });

        function initThumbnail(willBeAnimated){
            if(willBeAnimated){
                var carrousel = $(".card_wrapper");
                $(carrousel).prepend("<div class='card_thumbnail'></div>");
                $(".card_thumbnail").css("background-image",$('.carrousel--dynamic .accueil__carousel__items').find(".item2").css("background-image"));
            }
        }

        function setThumbnail(){
            var nextItem = $('.carrousel--dynamic .accueil__carousel__items').find(".active").next();
            var backgroundImage = $(nextItem).find(".accueil__carousel__item").css("background-image");
            $(".card_thumbnail").css("background-image",backgroundImage);
        }


        //Carrousel zoom
        $('.owl-carousel-zoom').each(function () {
            var $t = $(this);
            var willBeAnimated = $t.find('.owl-item-zoom').length > 1;
            $t.owlCarousel({
                items: 1,
                margin: 0,
                loop: willBeAnimated,
                nav: true,
                dots: false,
                // autoplay: willBeAnimated,
                mouseDrag: willBeAnimated,
                touchDrag: willBeAnimated,
                // autoplayTimeout: 8000,
                lazyLoad: true,
                autoplayHoverPause: true
            });
            if (willBeAnimated) {
                $t.find('.owl-controls').prepend('<button class="owl-prev"><span class="icon icon-arrow-utt-left"></span></button>').append('<button class="owl-next"><span class="icon icon-arrow-utt-right"></span></button>');
                $t.find('.owl-controls .owl-prev').click(function () {
                    $t.trigger('prev.owl.carousel');
                }).end().find('.owl-controls .owl-next').click(function () {
                    $t.trigger('next.owl.carousel');
                });
                var $numeros = $t.next('.accueil__carousel__bloc__numero').detach();
                $t.find('.owl-controls').append($numeros);
            }
            $t.on('changed.owl.carousel initialized.owl.carousel', function(e) {
                if (e.item) {
                    var index = e.item.index - 1;
                    var count = e.item.count;
                    if (index > count) {
                        index -= count;
                    }
                    if (index <= 0) {
                        index += count;
                    }
                    $t.find('.accueil__carousel__bloc__numero span').text((index < 10 ? '0' : '') + index);
                }
            });
        });
    });
})(jQuery.noConflict());

// UTM
(function() {
    const cookiesToAdd = [
        'gclid',
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content',
    ];
    const getCookie = function (name) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    };
    const getParam = function (name) {
        const value = '&' + window.location.search.slice(1);
        const parts = value.split('&' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split('&').shift();
        }
    }
    const addUTMToUrl = function (href) {
        const url = document.createElement('a');
        url.href = href;
        if (url.search) {
            url.search += '&';
        }
        for (let cookieName of cookiesToAdd) {
            const cookieValue = getCookie(cookieName);
            if (!!cookieValue) {
                url.search += cookieName + "=" + cookieValue + "&";
            }
        }
        url.search = url.search.substring(0, url.search.length - 1);
        return url.href;
    };
    const setCookie = function (name, value, days) {
        if (value) {
            const d = new Date();
            d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
            document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
        }
    }

    const eraseCookie = function (name) {
        document.cookie = name + '=; Max-Age=-99999999;';
    }

    document.addEventListener("DOMContentLoaded", function createCookieFromParam() {
        // S'il y a au moins 1 paramètre présent dans l'url on efface tous les cookies correspondants
        if (cookiesToAdd.filter((c) => !!getParam(c)).length > 0) {
            cookiesToAdd.map(eraseCookie);
        }
        cookiesToAdd.map((c) => setCookie(c, getParam(c), 30));
        // LIENS EXTERNES
        const externalLinks = document.querySelectorAll('a.lien_externe[href*="://allegorix.utt.fr"]');
        for (let i = 0; i < externalLinks.length; i++) {
            externalLinks[i].href = addUTMToUrl(externalLinks[i].href);
        }
    });
})();
// Fin UTM
